import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native"
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { ProfileAvatar } from "../..";
import styles from "../../../styles"
import { global, colors } from '../../../const'
import { family_ic, village_ic, placeholder } from "../../../assets/index"
import PrimaryTitle from "../../labels/PrimaryTitle";

export default function Groplist({ data, rightIcon, ...other }) {
    let avatar = placeholder
    if (data.kind === 1) avatar = family_ic
    else if (data.kind === 2) {
        if (window.Base64Img && window.Base64Img[data.avatar]) avatar = { uri: window.Base64Img[data.avatar] }
        else avatar = data.avatar ? { uri: global.MAKEURL(data.avatar) } : placeholder
    }
    else if (data.kind === 3) avatar = village_ic
    let title = data.kind === 1 ? data.family_name : data.nickname;
    let subTitle = data.kind === 1 ? data.group_chat_name : data.family_name;

    return (
        <TouchableOpacity
            activeOpacity={0.7}
            {...other}
        >
            <View style={pageStyle.root}>
                <View style={pageStyle.avatar}>
                    <ProfileAvatar src={avatar} />
                </View>
                <View style={pageStyle.row}>
                    <View style={{ flex: 1, paddingRight: 8 }}>
                        <PrimaryTitle>{title}</PrimaryTitle>
                        {subTitle && (
                            <PrimaryTitle
                                numberOfLines={1}
                                size={14}
                            >
                                {subTitle}
                            </PrimaryTitle>
                        )}
                    </View>
                    <Icon
                        icon={rightIcon ? rightIcon : faChevronRight}
                        color={colors.midnightBack}
                        style={{ position: "static" }}
                    />
                </View>
            </View>
            <View style={styles.divider} />
        </TouchableOpacity>
    )
}

const pageStyle = StyleSheet.create({
    root: {
        flexDirection: "row",
        alignItems: "center",
        padding: 10
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    avatar: {
        width: 50,
        height: 50,
        marginRight: 8
    },
    subTitle: {
        fontSize: 14,
        fontFamily: global.FONT_REGULAR,
        fontWeight: "400"
    }
})